var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-container"},[_c('div',[_vm._v("Elija la opción que describa el estado del dispositivo.")])])
}]

export { render, staticRenderFns }